export default "__VITE_ASSET__Ds2KAJmT__"